<template>
  <div class="asc-global-filter-table">
    <div class="asc-global-filter-table--header">
      <div class="asc-global-filter-table--header-select-unselect">
        <asc-list-filter-button
          v-model="listFilterStatus"
        ></asc-list-filter-button>
      </div>
      <div class="asc-global-filter-table--header-collapse-expand">
        <asc-accent-button
          :button-text="getExpandCollapseText"
          :on-click="handleTableExpandCollapse"
          :icon="getExpandCollapseIcon"
          secondary
        ></asc-accent-button>
      </div>
    </div>
    <div class="asc-global-filter-table--data">
      <asc-global-filter-table-item
        v-for="(item, index) in getTableItems"
        :key="index"
        :table-item="item"
        :filter-text="filterText"
        :on-expand-collapse="handleTableItemExpandCollapse"
        :on-update-header-data="handleTableItemUpdateHeaderData"
        :on-update-item-data="handleTableItemUpdateItemData"
      ></asc-global-filter-table-item>
    </div>
  </div>
</template>

<script>
import { AscGlobalFilterMixin } from '@/components/mixins'
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscListFilterButton from '@/components/atoms/AscListFilterButton'
import AscGlobalFilterTableItem from './AscGlobalFilterTableItem'

export default {
  name: 'AscGlobalFilterTable',

  components: {
    AscAccentButton,
    AscListFilterButton,
    AscGlobalFilterTableItem,
  },

  mixins: [AscGlobalFilterMixin],

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    groupedItems: {
      type: Boolean,
      default: false,
    },
    filterText: {
      type: String,
      default: '',
    },
    onUpdate: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      isExpanded: this.expanded,
      listFilterStatus: this.getListFilterStatus(this.items),
      tableItems: this.items,
    }
  },

  computed: {
    getTableItems() {
      return this.tableItems
    },

    getExpandCollapseText() {
      return this.isExpanded ? 'Collapse All' : 'Expand All'
    },

    getExpandCollapseIcon() {
      return this.isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
    },
  },

  watch: {
    items: {
      deep: true,
      handler(newItems) {
        this.listFilterStatus = this.getListFilterStatus(newItems)
        this.tableItems = newItems
      },
    },

    listFilterStatus(newValue) {
      if (newValue === 0) {
        this.handleClear()
      }
      if (newValue === 1) {
        this.handleSelectAll()
      }
    },
  },

  mounted() {
    this.handleIndeterminate()
  },

  methods: {
    handleTableExpandCollapse() {
      this.isExpanded = !this.isExpanded
      this.tableItems = this.tableItems.map(item => {
        return {
          ...item,
          expanded: this.isExpanded,
        }
      })

      this.handleInput()
    },

    handleTableItemExpandCollapse(value, expanded) {
      const tableItem = this.tableItems.find(ti => ti.value === value)
      if (tableItem) {
        tableItem.expanded = expanded
      }

      this.handleInput()
    },

    handleTableItemUpdateHeaderData(value, checked) {
      const tableItem = this.tableItems.find(ti => ti.value === value)
      if (tableItem) {
        tableItem.checked = checked
      }

      this.handleInput()
    },

    handleTableItemUpdateItemData(parentValue, childValue, checked) {
      const tableItem = this.tableItems.find(ti => ti.value === parentValue)
      if (tableItem) {
        const item = tableItem.items.find(item => item.value === childValue)
        if (item) {
          item.checked = checked
        }
      }

      this.handleInput()
    },

    handleIndeterminate() {
      this.listFilterStatus = this.getListFilterStatus(this.tableItems)
    },

    handleClear() {
      this.tableItems = this.tableItems.map(item => {
        const items = item.items.map(item => {
          return {
            ...item,
            checked: false,
          }
        })
        return {
          ...item,
          checked: false,
          items,
        }
      })

      this.handleInput()
    },

    handleSelectAll() {
      this.tableItems = this.tableItems.map(item => {
        const items = item.items.map(item => {
          return {
            ...item,
            checked: true,
          }
        })
        return {
          ...item,
          checked: true,
          items,
        }
      })

      this.handleInput()
    },

    handleInput() {
      this.handleIndeterminate()
      if (this.onUpdate) {
        this.onUpdate(this.tableItems)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-global-filter-table {
  width: 660px;

  &--header {
    height: 32px;
    background-color: $gray-300;
    display: flex;

    &-select-unselect {
      flex: 1 1 auto;

      .asc-list-filter-button--options-container {
        background-color: inherit;
        margin-left: 15px;

        .pretty.p-smooth label::before {
          border-color: $gray-600;
        }
      }
    }

    &-collapse-expand {
      flex: 0 0 135px;

      .asc-accent-button--accent.v-btn {
        background-color: inherit;
        border: 0;

        .v-btn__content {
          text-transform: none;
          font-weight: normal;
        }

        .v-icon {
          font-size: 20px !important;
        }
      }
    }
  }

  &--data {
    max-height: 340px;
    overflow-y: auto;
  }
}
</style>
